module.exports = __webpack_public_path__ + "img/billing.16b2135c.svg";